var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHomeLoader = function SvgHomeLoader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 475 400",
    style: {
      enableBackground: "new 0 0 475 400"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{\r\n\t\tfill: white;\r\n\t\tstroke:#EE8254;\r\n\t\tstroke-width: 17;\r\n\t\tstroke-dasharray: 1350;\r\n\t\tanimation: dash 3s linear infinite;\r\n\t\tstroke-dashoffset: 1350;\r\n\t}\r\n\t@keyframes dash{\r\n\t\t0%{\r\n\t\t\tstroke-dashoffset: 2700;\r\n\t\t}\r\n\t\t50%{\r\n\t\t\tstroke-dashoffset: 1350;\r\n\t\t}\r\n\t\t100%{\r\n\t\t\tstroke-dashoffset: 0;\r\n\t\t}\r\n\t}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.5,388V130c0-2.8-2.2-5-5-5h-56l210-112.3l210,112.3h-56c-2.8,0-5,2.2-5,5v258H88.5z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeLoader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/homeLoader.03801357.svg";
export { ForwardRef as ReactComponent };